document.addEventListener("DOMContentLoaded", function(){ // Handler when the DOM is fully loaded
   /* // Animate on scroll (require \bower_components\aos\dis\aos.js)
    AOS.init({
        offset: 150,
        once: true,
        disable: 'mobile',
        duration: 800,
        easing: 'ease-out-quad',
        delay: 100
    });

    window.addEventListener('scroll', function() {
        AOS.refresh();
    });*/

    document.addEventListener('click', function(event) {
        // Check if the clicked element is a link and the href is just '#'
        if (event.target.tagName === 'A' && event.target.getAttribute('href') === '#') {
            event.preventDefault(); // Prevent the default anchor behavior
        }
    });


    tippy('[data-tippy-content]',{theme : "white", interactive: true,allowHTML: true})

// Define a function to toggle classes for better reusability
    function toggleClasses(element, classes) {
        classes.forEach(cls => element.classList.toggle(cls));
    }

// Simplify removing classes
    function removeClasses(element, classes) {
        if(element !== null){
            classes.forEach(cls => element.classList.remove(cls));
        }
    }

// Helper function to add event listener with toggle functionality
    function addToggleListener(selector, toggleClass, target = null, focusTargetSelector = null) {
        const element = document.querySelector(selector);
        if (element !== null && target !== null){
            element.addEventListener('click', function() {
                if (target) {
                    target.classList.toggle(toggleClass);
                } else {
                    this.classList.toggle(toggleClass);
                }

                // Optional focus/blur for input elements
                if (focusTargetSelector !== null) {
                    const input = document.querySelector(focusTargetSelector);
                    if (input !== null) {
                        document.body.classList.contains(toggleClass) ? input.focus() : input.blur();
                    }
                }
            });
        }
    }

// Initialize toggle for the main menu and close button
   // addToggleListener("#btn-toggle", "active");
    addToggleListener("#toggler-global-search", "active");
    addToggleListener("#btn-toggle", "active-slide-menu", document.body);
    //addToggleListener("#btn-toggle-close", "active", document.getElementById("btn-toggle"));
    addToggleListener("#btn-toggle-close", "active-slide-menu", document.body);
    addToggleListener(".link-menu-activity", "_show-activity", document.querySelector(".slide-in-content"));
    addToggleListener(".link-menu-sorties", "_show-sorties", document.querySelector(".slide-in-content"));

    if(document.querySelector('.link-menu-activity') !== null){
        document.querySelector('.link-menu-activity').addEventListener("click", function() {
            var links = document.querySelectorAll('.slider-over-menu-sub .menu__list .menu-item .menu__item__el');
            links.forEach(function(link) {
                link.href = link.getAttribute('data-href-activites');
            });
        });
    }
    if(document.querySelector('.link-menu-sorties') !== null){
        document.querySelector('.link-menu-sorties').addEventListener("click", function() {
            var links = document.querySelectorAll('.slider-over-menu-sub .menu__list .menu-item .menu__item__el');
            links.forEach(function(link) {
                link.href = link.getAttribute('data-href-sorties');
            });
        });
    }

// Advanced search toggle and close
    addToggleListener("#toggle-avd-search", "active-avd-search", document.body);
    addToggleListener("#btn-avdsearch-close", "active-avd-search", document.body);

    addToggleListener("#btn-avdsearch-toggler", "open-toggler", document.getElementById("slider-search"));


// Close slide menu on Escape
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
            removeClasses(document.querySelector(".slide-in-content"), ['_show-activity','_show-sorties']);
            removeClasses(document.body, ['active-avd-search', 'active-slide-menu', 'active-login-menu', 'active-global-search', 'open-detailbox','open-modal-info']);
            if (document.activeElement) document.activeElement.blur();
        }
    });

// Global overlay click
    if(document.getElementById("global-overlay")){
        document.getElementById("global-overlay").addEventListener("click", function () {
            //removeClasses(document.getElementById("btn-toggle"), ['active']);
            removeClasses(document.querySelector(".slide-in-content"), ['_show-activity','_show-sorties']);
            removeClasses(document.body, ['active-avd-search', 'active-slide-menu', 'active-login-menu','open-detailbox','open-modal-info']);
        });
    }

// Login menu toggle
    addToggleListener(".logindropdown__close", "active-login-menu", document.body);
    document.querySelectorAll(".toggler-login").forEach(element => {
        element.addEventListener("click", function() {
            document.body.classList.toggle('active-login-menu');
        });
    });
    document.querySelectorAll('a[href="#login"]').forEach(element => {
        element.addEventListener("click", function() {
            document.body.classList.toggle('active-login-menu');
        });
    });
    document.querySelectorAll('.box__header--accordion').forEach(element => {
        element.addEventListener("click", function() {
            element.parentNode.classList.toggle('open-content');
            var btn = element.querySelector('.btn-accordion');
            if (btn) btn.setAttribute('aria-expanded', element.parentNode.classList.contains('open-content'));
        });
    });

// Global search toggle
    addToggleListener("#toggler-global-search", "active-global-search", document.body, "input");

    var errors = document.querySelectorAll('#gform_fields_login .validation_message');
    if (errors.length > 0) {
        document.body.classList.add('active-login-menu');
    }

    function handleHashChange() {
        var currentHash = window.location.hash.substring(1);

        // Find all li elements with class 'expando'
        var listItems = document.querySelectorAll('li.expando');

        // Check if any li has an ID that matches the current hash and add a class
        listItems.forEach(function(item) {
            if (item.id === currentHash) {
                item.classList.add("expando--open");
            }
        });
    }

// Attach the function to the hashchange event
    window.addEventListener("hashchange", handleHashChange, false);

// Call the function on page load
    handleHashChange();

});



